import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52641072"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "table table-tenant" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Party ID", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Row ID", -1))
const _hoisted_8 = {
  key: 0,
  style: {"height":"300px"}
}
const _hoisted_9 = { colspan: "12" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }

import { ref, onMounted } from "vue";
import ReportService from "../services/ReportService";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import { CommentType, commentTypeOptions } from "@/core/types/CommentType";
import { Search } from "@element-plus/icons-vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'CommentRecord',
  setup(__props) {

const isLoading = ref(false);
const data = ref<any>({});

const criteria = ref<any>({
  page: 1,
  size: 30,
});

const fetchData = async (_page: number) => {
  isLoading.value = true;
  console.log(commentTypeOptions.value);
  criteria.value.page = _page;
  try {
    const res = await ReportService.queryComments(criteria.value);
    data.value = res.data;
    criteria.value = res.criteria;
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

const reset = async () => {
  criteria.value = {
    page: 1,
    size: 30,
  };
  await fetchData(1);
};

onMounted(() => {
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_select, {
          modelValue: criteria.value.type,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.type) = $event)),
          placeholder: _ctx.$t('fields.type'),
          disabled: isLoading.value,
          clearable: "",
          onChange: _cache[1] || (_cache[1] = ($event: any) => (fetchData(1)))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(commentTypeOptions), (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder", "disabled"]),
        _createVNode(_component_el_input, {
          modelValue: criteria.value.partyId,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((criteria.value.partyId) = $event)),
          clearable: "",
          placeholder: "Party ID",
          disabled: isLoading.value,
          class: "ms-4 input-with-select",
          onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (fetchData(1)), ["enter"]))
        }, {
          append: _withCtx(() => [
            _createVNode(_component_el_button, {
              icon: _unref(Search),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (fetchData(1))),
              disabled: isLoading.value
            }, null, 8, ["icon", "disabled"])
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"]),
        _createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (reset())),
          disabled: isLoading.value,
          class: "ms-4"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.clear")), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("table", _hoisted_5, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.id")), 1),
            _hoisted_6,
            _hoisted_7,
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.type")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.content")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1)
          ])
        ]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_9, [
                  _createVNode(ScaleLoader, { color: '#ffc730' })
                ])
              ])
            ]))
          : (!isLoading.value && data.value.length == 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                _createVNode(_component_NoDataBox)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(item.id), 1),
                    _createElementVNode("td", null, _toDisplayString(item.partyId), 1),
                    _createElementVNode("td", null, _toDisplayString(item.rowId), 1),
                    _createElementVNode("td", null, _toDisplayString(_unref(CommentType)[item.type]), 1),
                    _createElementVNode("td", null, _toDisplayString(item.content), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_TimeShow, {
                        type: "GMToneLiner",
                        "date-iso-string": item.createdOn
                      }, null, 8, ["date-iso-string"])
                    ])
                  ]))
                }), 128))
              ]))
      ]),
      _createVNode(_component_TableFooter, {
        onPageChange: fetchData,
        criteria: criteria.value
      }, null, 8, ["criteria"])
    ])
  ]))
}
}

})